import React from 'react';
import { motion } from 'framer-motion';
import { Toggle } from '../../ui/Toggle/Toggle';

export interface DeviceControlProps {
  id: string;
  name: string;
  subtext?: string;
  icon: React.ReactNode;
  status: 'on' | 'off';
  isOnline: boolean;
  onToggle: (id: string) => void;
  className?: string;
}

export const DeviceControl: React.FC<DeviceControlProps> = ({
  id,
  name,
  subtext,
  icon,
  status,
  isOnline,
  onToggle,
  className = '',
}) => {
  const isOn = status === 'on';

  return (
    <motion.div
      className={`
        bg-[#F8F8F8] rounded-2xl p-4 flex items-center gap-4
        ${!isOnline ? 'opacity-50' : ''}
        ${className}
      `}
      whileHover={isOnline ? { y: -2 } : undefined}
      transition={{ duration: 0.2 }}
    >
      {/* Icon Container */}
      <div className="w-12 h-12 rounded-full bg-[#FDF6E9] flex items-center justify-center flex-shrink-0">
        <div className="text-[#D4A054] w-6 h-6 flex items-center justify-center">
          {icon}
        </div>
      </div>

      {/* Text Content */}
      <div className="flex-1 min-w-0">
        <h3 className="text-[#333333] text-base font-medium truncate">
          {name}
        </h3>
        <motion.p
          key={isOn ? 'on' : 'off'}
          initial={{ opacity: 0, y: -5 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.15 }}
          className={`text-sm ${isOn ? 'text-[#D4A054]' : 'text-[#666666]'}`}
        >
          {isOn ? 'On' : 'Off'}
          {!isOnline && ' (Offline)'}
        </motion.p>
        {subtext !== undefined && subtext !== '' && (
          <p className="text-xs text-[#999999] truncate">{subtext}</p>
        )}
      </div>

      {/* Toggle Switch */}
      <Toggle
        checked={isOn}
        onChange={() => onToggle(id)}
        disabled={!isOnline}
      />
    </motion.div>
  );
};

export default DeviceControl;
